/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const expandButton = document.querySelector('.expand-button');
  const collapseButton = document.querySelector('.collapse-button');
  const visibleContent = document.querySelector('.visible-content');
  const hiddenContent = document.querySelector('.hidden-content');
  const overlay = document.querySelector('.gradient-overlay');

    console.log(expandButton);
    if(expandButton) {
        hiddenContent.style.maxHeight = '0';
        hiddenContent.style.overflow = 'hidden';
        expandButton.addEventListener('click', function () {
            overlay.classList.add('hidden');  
            hiddenContent.classList.add('revealed');  
        });
    
        collapseButton.addEventListener('click', function () {
            hiddenContent.classList.remove('revealed'); 
            overlay.classList.remove('hidden');  
        });
        
    }





  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
